import { CategoryDisplayer } from '@components';
import { useGenericCart } from '@contexts/GenericCartContext/GenericCartContext';
import { Button, Container, Icon, IconButton, Typography } from '@design-system';
import React from 'react';
import { FaShoppingBasket, FaStar } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './ApprovisionnementPage.scss';

export const ApprovisionnementPage: React.FC = () => {
    const { getTotalItems } = useGenericCart({ type: 'appro' });

    const totalItems = getTotalItems();
    const navigate = useNavigate();
    return (
        <div className="approvisionnement-page">
            <Container className="approvisionnement-page-header" padding="medium large" radius="none" flexRow>
                <Button color="green" variant="secondary" size="small" onClick={() => navigate('/mes-chantiers/approvisionnement/orders')}>
                    <Typography intrinsic="h4">Mes commandes</Typography>
                </Button>

                <div className="approvisionnement-page-header-cart">
                    <IconButton
                        icon={<Icon icon={<FaShoppingBasket />} size={24} color="grey" />}
                        onClick={() => navigate('/mes-chantiers/approvisionnement/cart')}
                    />
                    {totalItems ? (
                        <Typography intrinsic="h4" className="total-items">
                            {totalItems}
                        </Typography>
                    ) : (
                        <></>
                    )}
                </div>
            </Container>

            <Container padding="medium large" radius="none">
                <Container className="header-categories mb-medium-spacing" padding="none" flexRow>
                    <Typography intrinsic="h2">Catégories</Typography>
                    <Button
                        color="grey"
                        variant="tertiary"
                        size="small"
                        icon={<FaStar />}
                        secondaryIcon={<MdKeyboardArrowRight className="ml--x-small-spacing" />}
                        className="no-padding"
                        onClick={() => navigate('/mes-chantiers/approvisionnement/orders/favorites')}
                    >
                        <Typography intrinsic="h4">Favoris</Typography>
                    </Button>
                </Container>
                <CategoryDisplayer />
            </Container>
        </div>
    );
};
